import React, { useState, useEffect } from "react";
import { quotes } from "../data/quotes";
import styles from "./DailyQuote.module.css";

function DailyQuote() {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    // Generate a new quote based on the day of the year
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 0);
    const dayOfYear = Math.floor((today - startOfYear) / 1000 / 60 / 60 / 24);

    // Use the day of the year to get a different quote each day
    const dailyQuoteIndex = dayOfYear % quotes.length;
    setQuote(quotes[dailyQuoteIndex]);
  }, []); // Run once on component load

  return (
    <div className={styles.container}>
      <p className={styles.quoteText}>{quote}</p>
    </div>
  );
}

export default DailyQuote;
